<template lang="pug">
  v-layout
    v-dialog(v-model="openPopup" persistent width="363")
      v-card
        v-card-title(style="padding: 0.2em 0.2em;")
          v-layout(row)
            v-flex
              v-btn(style="float: right;" icon @click="closePopup")
                v-icon(color="#0855C4") close
        v-card-text(style="padding-top: 0;")
          v-layout(column align-center)
            v-flex
              v-img
                img(:src="icon")
            v-flex
              Span(style="font-size: 24px;color: #0855C4;font-weight:bold") {{ titulo || '¡Feliz 7º años juntos!'}}
            v-flex(style="text-align: center;width: 21em;margin-top:1em;margin-bottom:2em")
              span(style="font-size: 18px;line-height: normal;color: #535D66;") {{ mensaje || 'Hoy queremos celebrar tu compromiso con los que más amas, sigue asegurando la tranquilidad de tu familia.'}}
            v-flex(style="    margin-bottom: 2em;")
              v-btn(style="width: 15em;height: 4em;" color="#EA0D90")
                span(style="text-transform: capitalize;color:#ffffff;font-size: 17px;") {{textoBoton || 'Ver Historial'}}
</template>

<script>
export default {
  props: [
    'openPopup'
  ],
  data () {
    return {
      icon: require('./../../assets/icons/gif-aniversario.gif')
    }
  },
  methods: {

  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/PopupAniversario.vue